import applicationStore from "../ApplicationStore";
import { AuthRedirect } from '../../auth/authRedirect';
import { ActionType } from ".";
import RestClient from "../../integration/RestClient";

export class AuthActions {

  static setAuthManager(data: AuthRedirect | null) {
    applicationStore.dispatch({ type: ActionType.AUTH_MANAGER_SET, data });
  }

  static userSignedIn() {
    applicationStore.dispatch({ type: ActionType.AUTH_SIGNED_IN });
  }

  static userSignedOut() {
    applicationStore.dispatch({ type: ActionType.AUTH_SIGNED_OUT });
  }

  static async getCurrentUserPermissions() {
    const data: any = await RestClient.userPermissions.apiUserPermissionsGetGlobalPermissionsGet()
    data.ssrCredentials = "FullControl"
    applicationStore.dispatch({ type: ActionType.AUTH_GET_CURRENT_USER_PERMISSIONS, data });
  }

}
